import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './MiraklButton.module.scss';
import { ReactComponent as MiraklLogo } from './mirakl-logo.svg';

const MiraklButton = (props) => {
  const { disabled, text, light, size } = props;

  const onClick = () => {
    if (!disabled) {
      props.onClick();
    }
  };

  return (
    <div
      onClick={onClick}
      className={cn(
        styles.btnConnect,
        light ? styles.light : styles.dark,
        disabled ? styles.disabled : '',
        size === 'small' ? styles.small : '',
      )}
    >
      <div className={styles.logoMirakl}>
        <MiraklLogo />
      </div>
      <span>{text || 'Sign in with Mirakl'}</span>
    </div>
  );
};

export default MiraklButton;

MiraklButton.defaultProps = {
  disabled: false,
  light: false,
  size: 'normal',
};

MiraklButton.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  light: PropTypes.bool,
  size: PropTypes.string,
};
